module.exports = __webpack_public_path__ + "img/store-shopware.8f3eb813.svg";